// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3HV-6","buttons":"SendReceipts_buttons__3mxtL","email":"SendReceipts_email__2G84a","bookApptTitle":"SendReceipts_bookApptTitle__ZSH44"};